import React from 'react';

const ProductPlaceholder = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      {/* Frasco de medicamento/suplemento */}
      <g>
        {/* Cuerpo del frasco */}
        <rect
          x="60"
          y="70"
          width="80"
          height="100"
          rx="8"
          fill="#e0e0e0"
          stroke="#b0b0b0"
          strokeWidth="2"
        />

        {/* Tapa del frasco */}
        <rect
          x="70"
          y="50"
          width="60"
          height="25"
          rx="4"
          fill="#9e9e9e"
          stroke="#757575"
          strokeWidth="2"
        />

        {/* Tapa superior */}
        <rect
          x="75"
          y="40"
          width="50"
          height="15"
          rx="3"
          fill="#757575"
        />

        {/* Etiqueta del frasco */}
        <rect
          x="70"
          y="85"
          width="60"
          height="50"
          rx="4"
          fill="#f5f5f5"
          stroke="#d0d0d0"
          strokeWidth="1"
        />

        {/* Líneas de texto en la etiqueta */}
        <line x1="80" y1="95" x2="120" y2="95" stroke="#b0b0b0" strokeWidth="2" strokeLinecap="round" />
        <line x1="80" y1="105" x2="115" y2="105" stroke="#d0d0d0" strokeWidth="2" strokeLinecap="round" />
        <line x1="80" y1="115" x2="110" y2="115" stroke="#d0d0d0" strokeWidth="2" strokeLinecap="round" />
        <line x1="80" y1="125" x2="120" y2="125" stroke="#d0d0d0" strokeWidth="2" strokeLinecap="round" />

        {/* Reflejo de luz en el frasco */}
        <ellipse
          cx="85"
          cy="90"
          rx="8"
          ry="12"
          fill="white"
          opacity="0.4"
        />
      </g>
    </svg>
  );
};

export default ProductPlaceholder;
